export default {
  providersById: {},
  register(provider) {
    this.providersById[provider.id] = provider;
    return provider;
  },
};



// WEBPACK FOOTER //
// ./src/services/providers/common/providerRegistry.js